import { computed, reactive } from "vue"
import { toUrl, toWatermark } from "@/utils"
import type { Color, CustomSpu, SimpleSku, CustomableImages, CustomableImage, DesginShareThemeCustomizedImage, CartData, SimpleSpu, RawCustomizedImage, CustomizedImage } from "../configure"
export const templateBasicParameters = (customableImages: CustomableImages | CustomableImage, cornerSize: number = 15) => {
  // 部分altImages为空 设一个默认色 黑色作为代码保护
  let color = '#000000'
  if (customableImages.altImages && customableImages.altImages[0] && customableImages.altImages[0].attrs && customableImages.altImages[0].attrs[0].object_value.value) {
    color = customableImages.altImages[0].attrs[0].object_value.value
  }
  return Object.assign({}, { image: customableImages.image, color, width: customableImages.width, height: customableImages.height, cornerSize })
}

export const assignCustomizedData = computed(() => (record: any, customSpu?: any) => {
  if (record.custom_areas) {
    return Object.assign({},
      { ...(record.custom_areas || {}) },
      { scale: (200 / record.width) * (record.custom_areas.scale) },
      record.customized_areas.boundingRect || {})
  }
})

export const removeDuplicates = (array: any) => {
  const uniqueItems: { [key: string]: DesginShareThemeCustomizedImage } = {}
  array.forEach((item: DesginShareThemeCustomizedImage) => {
    uniqueItems[item.url] = item
  })
  return Object.values(uniqueItems)
}

export const renderImageCustomUrl = (record: any, customSpu?: any) => {
  if (record.custom_areas) {
    const scaleRatio = record.customized_areas.customable_image_scale || record.spu_custom_areas.scale
    // const heightRatio = Math.round((record.customized_areas.boundingRect?.height) * (200 / (record.custom_areas.width || customSpu.spu_custom_width)) * scaleRatio)
    const widthRatio = Math.round((record.customized_areas.boundingRect?.width) * (200 / (record.custom_areas.width || customSpu.spu_custom_width)) * scaleRatio)
    const renderCustomUrl = toWatermark(toUrl(record.customized_image)!) + `?x-oss-process=image/resize,w_${widthRatio}/quality,q_90`
    return renderCustomUrl
  } else
    return toUrl(record.image)
}

export const assignDssProductCustomizedData = (record: any) => {
  return Object.assign({},
    { ...(record.customableImage.custom_areas || {}) },
    { scale: (200 / record.customableImage.width) * (record.customableImage.custom_areas.scale) },
    record.customized_areas.boundingRect || {})
}

export const renderDssProductImageCustomUrl = (record: any) => {
  const scaleRatio = record.customized_areas.customable_image_scale || record.spu_custom_areas.scale
  // const heightRatio = Math.round((record.customized_areas.boundingRect?.height) * (200 / (record.customableImage.custom_areas.width)) * scaleRatio)
  const widthRatio = Math.round((record.customized_areas.boundingRect?.width) * (200 / (record.customableImage.custom_areas.width)) * scaleRatio)
  const renderCustomUrl = toWatermark(toUrl(record.customized_image)!) + `?x-oss-process=image/resize,w_${widthRatio}/quality,q_90`
  return renderCustomUrl
}

export const convertSpuToSimpleSpu = (customSpu: CartData): SimpleSpu => {
  const colors: Array<Color> = []
  let sizes: Array<string> = []
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const skus: SimpleSku[] = []
  customSpu.skus?.forEach((item) => {
    const sku: SimpleSku = {
      key: 0,
      color: undefined,
      size: '',
      code: '',
      id: 0
    }
    sku.key = item.id
    sku.code = item.code
    sku.id = item.id
    const skuAttrs = !customSpu.is_custom ? item.attrs : item.sku?.attrs
    skuAttrs?.forEach((arr) => {
      if (arr.attribute.key === 'color') {
        const c = convertColor(arr.value || arr.object_value)
        sku.color = c
        item.color = c
        if (c && !colors.find(a => c.value === a.value)) {
          colors.push(c)
        }
      }
      if (arr.attribute.key === 'size') {
        sizes.push(arr.value)
        sku.size = arr.value
        item.size = arr.value
      }
    })
    skus.push(sku)
  })
  sizes = [...new Set(sizes)]
  return {
    colors,
    sizes,
    customSkus: skus,
  }
}

/**
 * 从AltImages里查找匹配当前颜色的备用图片
 *
 * @param color
 * @param customableImage
 * @returns
 */
export const findCustomableImage = (color: Color, customableImage: CustomableImage) => {
  if (color && customableImage.altImages && customableImage.altImages.length >= 0) {
    const altImage = customableImage.altImages.find(i => {
      return i.attrs?.find(attr => {
        return attr.spuAttr.attribute.key === 'color'
          && convertColor(attr.value || attr.object_value)?.value === color.value
      })
    })
    if (altImage && altImage.alt_image) {
      return altImage.alt_image
    }
  }
  return customableImage.image
}

export const sortBy = (attr: any, rev: any) => {
  // 第二个参数没有传递 默认升序排列
  if (rev == undefined) {
    rev = 1
  } else {
    rev = (rev) ? 1 : -1
  }

  return function (a: any, b: any) {
    a = a[attr]
    b = b[attr]
    if (a < b) {
      return rev * -1
    }
    if (a > b) {
      return rev * 1
    }
    return 0
  }
}

export const convertToCustomizedImage = (image: RawCustomizedImage): CustomizedImage => {
  const o = Object.assign({
    customized_image: image.customized_image,
    price: image.price
  }, image.customableImage, image.customized_areas) as unknown as CustomizedImage
  return o
}


export const convertColor = (strColor: any): Color | undefined => {
  if (typeof strColor !== 'string') {
    return strColor
  }

  try {
    return JSON.parse(strColor)
  } catch (e) {
    return { name: '', value: strColor }
  }
}

export const convertCustomSpuToSimpleSpu = (customSpu: CustomSpu): SimpleSpu => {
  const colors: Array<string> = []
  let sizes: Array<string> = []
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const skus: SimpleSku[] = []
  customSpu.customSkus.forEach((item) => {
    const sku: SimpleSku = {
      key: 0,
      color: undefined,
      size: '',
      code: '',
      customCode: 0,
      id: 0
    }
    sku.key = item.id
    sku.customCode = item.id
    sku.code = item.code
    item.sku.attrs.forEach((arr) => {
      if (arr.attribute.key === 'color') {
        const c = convertColor(arr.value || arr.object_value)
        sku.color = c
        item.color = c
        if (c && !colors.find(a => c.value === a)) {
          colors.push(c.value)
        }
      }
      if (arr.attribute.key === 'size') {
        sizes.push(arr.value)
        sku.size = arr.value
        item.size = arr.value
      }
    })
    skus.push(sku)
  })
  sizes = [...new Set(sizes)]
  return {
    colors,
    sizes,
    customSkus: skus,
  }
}